jQuery(function($) {
  const $meeting_cards = $('.resource-carousel');
  let settings_slider = {
    dots: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1099,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: true
        }
      }
    ]
  };

  $meeting_cards.slick(settings_slider);

  $(window).resize(function() {
    let $width = $(window).width();
    if ($width < 1099 && !$('.resource-carousel').hasClass('slick-initialized')) {
      $meeting_cards.slick(settings_slider);
    }
  });

  $('#JS-filter-resource').change(function() {
    let $selected_value = $('#JS-filter-resource option:selected').val();
    $('.resource-wrap').removeClass('unhidden');
    $('.firstresult').removeClass('firstresult');
    $('#' + $selected_value).addClass('unhidden');
    let $selected_carousel = $('#' + $selected_value + ' .resource-carousel').first();
    $selected_carousel.slick('slickGoTo', 0);
  });

  $(window).load(function() {
    let $selected_value = $('#JS-filter-resource option:selected').val();
    $('.filter-resource-spotlight .resource-wrap').removeClass('unhidden');
    $('#' + $selected_value).addClass('firstresult');
    let $selected_carousel = $('#' + $selected_value + ' .resource-carousel').first();
    $selected_carousel.slick('slickGoTo', 0);
  });

});
